<ng-container *transloco="let t">
  @if (sadmEntity().canWrite) {
    <button
      appearance="form-trigger"
      data-testid="document-shortcut"
      iconStart="@tui.table-2"
      size="s"
      tuiHintDirection="top-start"
      tuiIconButton
      type="button"
      [tuiHint]="t('Ouvrir le tableau de la lésion')"
      (click)="openGrid()">
      {{ t('Ouvrir le tableau de la lésion') }}
    </button>
  }
</ng-container>
